module.exports = __webpack_public_path__ + "assets/img/guohui.6759a3e0.png";